module.exports = __webpack_public_path__ + "img/icon_waiting@2x.2587a0bd.png";